import { c as _c } from "react/compiler-runtime";
import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { ATTRIBUTE_MULTI_PREFIX } from '@shared/config';
import { ROUTES } from '@shared/routes';
import { toSentenceCase } from '@shared/utils';
import { usePathname } from 'next/navigation';
import { type FC } from 'react';
export const Breadcrumbs: FC = () => {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    const paths = pathname.split("/").filter(Boolean);
    const homeHref = ROUTES.home;
    t0 = <MUIBreadcrumbs aria-label="breadcrumb">{!paths.length ? <Typography color="text.primary">Home</Typography> : <Link underline="hover" color="secondary" href={homeHref}>Home</Link>}{paths.map((path, i) => {
        const routeName = toSentenceCase(decodeURI(path).replaceAll(ATTRIBUTE_MULTI_PREFIX, ""));
        const route = `/${[...paths].splice(0, i + 1).join("/")}`;
        return i !== paths.length - 1 ? <Link underline="hover" color="secondary" key={path} href={route}>{routeName}</Link> : <Typography key={routeName} color="text.primary">{routeName}</Typography>;
      })}</MUIBreadcrumbs>;
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};